import _ from 'lodash';

export const ensureListingTypes = (config) => {
  return _.cloneDeep(config)?.listing.listingTypes.map(lt => {
      return {
        ...lt,
        stockType: lt.stockType || 'multipleItems',
      }
    }) || [];
};
